const defaultFormThemeColor = "#1f6fd9";

export default defaultFormThemeColor;
